<template>
		<div class="teikiArea"
			v-if="(ptInitData.teikiKounyuuOption == 1 && ptInitData.productInfo.TEIKI_KOUNYUU_KANOU_FLG == 1)">
			<cartContainer :ptInitData="ptInitData" :doChkCartAddTxt="doChkCartAddTxt" :isLp="isLp" :teikiKounyuu="1"
				@pt125doOrder="pt125doOrder" />
		</div>
</template>
<script>

import cartContainer from './cartContainer.vue'
export default {
	components: {
		cartContainer
	},
	methods: {
		pt125doOrder: function (e) {
			this.$emit('pt125doOrder', e);
		}
	},
	name: 'teikiCartContainer',
	props: {
		ptInitData: {
			type: Object,
			default: null
		},
		doChkCartAddTxt: {
			type: Boolean
		},
		isLp: {
			type: Boolean,
			default: false
		},
		teikiKounyuu: {
			type: Number,
			default: 0
		}
	}
}
</script>